import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { number: "₦50M+", label: "Processed across multi-currency wallets, zero balance inconsistencies" },
  { number: "<200ms", label: "API latency at 10K+ daily active users (down from ~800ms)" },
  { number: "10,000+", label: "Artists evaluated on the AFRIMA continental adjudication platform" },
  { number: "14", label: "Published mobile apps on Google Play and the App Store" },
  { number: "5+", label: "Years building production backend & mobile systems" },
];

const ImpactStrip = () => {
  return (
    <div className="impact-strip py-4">
      <div className="container2">
        <motion.div
          className="impact-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {stats.map((stat, index) => (
            <div className="impact-tile" key={index}>
              <span className="impact-number">{stat.number}</span>
              <small className="impact-label">{stat.label}</small>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ImpactStrip;
